<template>
  <div>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <v-row style="padding: 0px !important; margin: 0px !important">
              <v-col cols="4"> Bank Account Selection</v-col>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-autocomplete
                  hide-details="auto"
                  :items="BankDatas"
                  :loading="loadingbanks"
                  v-model="selectBank"
                  item-text="name"
                  label="Search Bank"
                  outlined
                  dense
                  clearable
                  :search-input.sync="searchBank"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-title>
          <v-expansion-panels v-if="loadingDatas">
            <v-expansion-panel v-for="(item, i) in BankDatas" :key="i">
              <v-expansion-panel-header>
                {{ item.name }}
              </v-expansion-panel-header>
              <v-expansion-panel-content color="#e3e3e3">
                <SingleAccount
                  :bankdata="item"
                  ref="bankAcc"
                  @selectedBankAccount="selectedBankAccount"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SingleAccount from './AccountCardsView.vue';

export default {
  data: () => ({
    BankDatas: [],
    loadingbanks: false,
    loadingDatas: false,
    searchBank: null,

    isLoading: false,
    messages: '',
  }),
  created() {
    this.GetBankByQuery();
  },
  components: {
    SingleAccount,
  },
  watch: {
    searchBank: {
      handler(val) {
        this.GetBankByQuery(val);
      },
      deep: true,
    },
  },
  methods: {
    emitInput() {
      this.$emit('input', this.selectBank);
    },

    callingRefresh() {
      this.$refs.bankAcc[0].refreshModule();
    },
    GetBankByQuery(query = '') {
      this.isLoading = true;
      this.loadingDatas = false;
      if (query == null) {
        query = '';
      }

      this.$store
        .dispatch('shop/getBankDetails', query)
        .then((res) => {
          this.BankDatas = res.data.data;
          this.isLoading = false;
          this.loadingDatas = true;
        })
        .catch((err) => {
          this.isLoading = false;
          this.loadingDatas = true;

          this.messages = err.data.name;
        });
    },
    selectedBankAccount(data) {
      this.$emit('selectedBankAccount', data);
    },
  },
};
</script>
